export default "__VITE_ASSET__BtNRwhpd__"